<script setup lang="ts">
import t from "~/utils/translate";
import Feeds from "~/components/layout/Feeds/Feeds.vue";
import { useAuth } from "~/store/auth";
import { storeToRefs } from "pinia";
import useFeeds from "~/composables/Feeds/useFeeds";
import { mdiInformationOutline } from "@mdi/js";
import { useBetslip } from "~/store/betslip";
import PublicProfileAvatar from "~/components/layout/Feeds/Avatar/PublicProfileAvatar.vue";
import { IMarket } from "~/types/sports/market";
import { IOutcome } from "~/types/sports/outcome";
import { IPrice } from "~/types/sports/price";
import { IEvent } from "~/types/sports/event";
import { IScore } from "~/types/sports/score";
import FeedsInfoModal from "~/components/layout/Feeds/Shared/FeedsInfoModal.vue";
import { useSettings } from "~/store/settings";
import { isMobile } from "~/utils/constants";

const { feedsEmop, followedItems, leagues, followingCards } = useFeeds();
const auth = useAuth();
const settings = useSettings();
const { loggedIn } = storeToRefs(auth);
const emit = defineEmits(["error"]);

watchEffect(() => {
	if (!auth.loggedIn) {
		feedsEmop.value = {
			markets: new Map<number, IMarket>(),
			outcomes: new Map<number, IOutcome>(),
			prices: new Map<number, IPrice>(),
			events: new Map<number, IEvent>(),
			scores: new Map<number, IScore>(),
		};
		followingCards.value = [];
		leagues.value = new Map();
		followedItems.value = [];
	}
});

const infoActive = ref(false);
</script>

<template>
	<UiSidebarCard
		:pt="{
			headerClass: 'flex items-center w-full px-2 py-2 text-xs font-bold rounded-t-lg md:text-base bg-dark-800 text-light-50 dark:bg-dark-700',
			bodyClass: 'gap-2 pb-0 h-full bg-light-300 dark:bg-dark-900 dark:border dark:border-dark-800 border-t-none overflow-y-auto',
		}"
		v-if="loggedIn && !isMobile"
	>
		<template #header>
			<div class="flex flex-nowrap justify-between w-full">
				<div class="flex gap-2 items-center">
					<PublicProfileAvatar :size="30" class="cursor-pointer" @click="settings.feedsProfileModal = true" />
					<span>
						{{ t("feeds") }}
					</span>
				</div>

				<UiButton
					variant="custom"
					size="custom"
					:icon="mdiInformationOutline"
					rootClass="h-[24px] w-[24px]"
					iconClass="fill-light-50 h-[24px] w-[24px]"
					@click="settings.feedsInfoModal = true"
				/>
			</div>
		</template>
		<Feeds />
		<FeedsInfoModal v-if="infoActive" :active="infoActive" @set-active="infoActive = false" />
	</UiSidebarCard>
</template>

<style scoped lang="scss"></style>
